module.exports = __webpack_public_path__ + "img/76246.07b75797.svg";